/* Algolia InstantSearch - 2026 design enhancer (ASCII-safe, ES5).
   1) Replaces the app's product hit template with the h26 card
      (own markup + classes; no cascade conflicts with app CSS).
   2) Rewrites the /search H1 to: Results for "query" + product count.
   3) Appends the Not-finding-it callout to the facet rail.
   4) Relabels pagination (Prev/Next, hides first/last jumps). */
(function () {
  window.__h26Enhancer = 'loaded';

  /* SPID part number for cards (2026-07-26, Patrick). Same normalisation as
     snippets/spid-part-number.liquid and sections/printer-specs-supplies.liquid:
     drop the "-Q<n>" quantity suffix, prefix a leading 0 for Fargo. Published on
     window so assets/algolia-swatches.js reuses it whichever file loads first. */
  var pnDisp = window.__spidPnDisp || function (sku, vendor) {
    var s = String(sku == null ? '' : sku).split('-Q')[0].replace(/^\s+|\s+$/g, '');
    if (!s) return '';
    if (String(vendor == null ? '' : vendor).toLowerCase().indexOf('fargo') !== -1 && s.charAt(0) !== '0') s = '0' + s;
    return s;
  };
  window.__spidPnDisp = pnDisp;

  /* Money in the Liquid `money` filter's shape (thousands separators), so an
     Algolia card and a Liquid card print the same string. */
  var money = window.__spidMoney || function (n) {
    n = Number(n);
    if (!isFinite(n)) n = 0;
    var p = n.toFixed(2).split('.');
    return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
  };
  window.__spidMoney = money;

  /* ---------- MAP / MAPP guard (2026-07-28, Patrick) ----------
     Manufacturer minimum-advertised-price rules: when the selling price is
     below MAP we may not print the number. Show the MAP struck through plus
     "Add to Cart for Price" instead -- the same treatment as the Liquid cards
     (snippets/card-product.liquid) and the PDP (assets/custom-product-pricing.js).
     MAP is the source of truth and the ONLY trigger (Patrick, 2026-07-28):
       1. meta.c_f.map -- the c_f.map product metafield, added to the Algolia
          index 2026-07-28. Dollars, same unit as hit.price. Where a MAP
          exists it decides on its own: hide the number ONLY when the MAP is
          strictly ABOVE the selling price. A price equal to (or above) MAP
          is already compliant and needs no treatment at all.
       2. the hide_searchanise_price tag -- the hand-maintained list the old
          search app used. Demoted to a fallback for records carrying no
          c_f.map value at all (the Algolia Shopify app indexes PRODUCT
          metafields only, so a variant-level MAP override can arrive with
          no map on the record). It can no longer override a known MAP.
     Published on window so assets/algolia-swatches.js reuses it whichever file
     loads first. */
  var mapGuard = window.__spidMapGuard || (function () {
    function num(v) {
      if (v == null) return 0;
      var n = parseFloat(String(v).replace(/[^0-9.\-]/g, ''));
      return (isFinite(n) && n > 0) ? n : 0;
    }
    function mapOf(hit) {
      var m = hit && hit.meta && hit.meta.c_f;
      return m ? num(m.map) : 0;
    }
    function tagged(hit) {
      var t = (hit && (hit.tags || hit._tags)) || [];
      if (typeof t === 'string') { t = [t]; }
      for (var i = 0; i < t.length; i++) {
        if (String(t[i]).toLowerCase() === 'hide_searchanise_price') return true;
      }
      return false;
    }
    /* Configure-to-price products (2026-08-02, Patrick). Two custom-lanyard
       products carry a 0.00 variant price because Fancy Product Designer
       computes the real figure from the design and quantity at design time.
       The variant price must stay at 0.00 -- giving it a real base price
       risks FPD adding to it at checkout rather than replacing it -- so the
       card never prints a number and shows what to do next instead. Anything
       without a usable positive price is treated this way, which also makes a
       missing/NaN price fail safe (withhold, never guess). */
    function configurable(hit, price) {
      var p = Number(price == null ? (hit && hit.price) : price);
      return !(isFinite(p) && p > 0);
    }
    function hide(hit, price) {
      var p = Number(price == null ? (hit && hit.price) : price);
      var m = mapOf(hit);
      /* No usable selling price: configure-to-price. Withhold regardless. */
      if (!(isFinite(p) && p > 0)) return true;
      /* A usable MAP settles it by itself -- including the equal case, which
         is compliant and gets the ordinary price line. Only fall through to
         the tag when there is no MAP to evaluate. */
      if (m > 0) return p < m;
      return tagged(hit);
    }
    /* Which call to action a withheld price carries. MAP products tell the
       shopper the price appears in the cart; configure-to-price products
       tell them there is no price until they build it. */
    function ctaLabel(hit, price) {
      return configurable(hit, price) ? 'Design & See Price' : 'Add to Cart for Price';
    }
    /* The MAP value we are allowed to PRINT as the struck-through "was" price.
       (2026-07-28) Showing the MAP is legitimate -- MAP is by definition an
       advertisable price -- but only while it sits ABOVE the selling price.
       63 tagged products are priced exactly AT their MAP, and for those,
       printing the MAP prints the very number we were told to withhold. A
       MAP at or below the selling price is therefore never rendered; the
       card falls back to a bare "Add to Cart for Price". */
    function strikeMap(hit, price) {
      var m = mapOf(hit);
      var p = Number(price == null ? (hit && hit.price) : price);
      return (m > 0 && isFinite(p) && p > 0 && m > p) ? m : 0;
    }
    /* the price line for a MAP-restricted record: struck MAP + CTA when we
       have a printable MAP, bare CTA otherwise. Callers pass strikeMap(). */
    function ctaHtml(mapValue, label) {
      return (mapValue > 0 ? '<s>' + money(mapValue) + '</s>' : '') +
        '<b class="h26-card__cta">' + (label || 'Add to Cart for Price') + '</b>';
    }
    return { num: num, mapOf: mapOf, tagged: tagged, hide: hide, ctaHtml: ctaHtml, strikeMap: strikeMap, configurable: configurable, ctaLabel: ctaLabel };
  })();
  window.__spidMapGuard = mapGuard;

  /* mapGuard may have been published by a cached copy of algolia-swatches.js
     that predates ctaLabel(); fall back to the MAP wording rather than
     printing "undefined" on a card. */
  function ctaFor(hit, price) {
    return mapGuard.ctaLabel ? mapGuard.ctaLabel(hit, price) : 'Add to Cart for Price';
  }

  /* handles the autocomplete hook decided to hide (handle -> MAP dollars) */
  var acHidden = {};

  /* part numbers for the autocomplete rows (handle -> display part number).
     Recorded for every product item the template hook sees, printed by
     acSkuLine() below. */
  var acSkus = {};

  /* Depth-first search of a preact/htm vdom tree for the first node carrying
     `cls` in its class attribute. Used to swap the price node of the app's
     stock autocomplete item without rebuilding the whole template. */
  function findVNode(node, cls) {
    if (!node || typeof node !== 'object') return null;
    if (Object.prototype.toString.call(node) === '[object Array]') {
      for (var i = 0; i < node.length; i++) {
        var r = findVNode(node[i], cls);
        if (r) return r;
      }
      return null;
    }
    var p = node.props;
    if (!p) return null;
    var c = p.class || p.className || '';
    if (typeof c === 'string' && c.indexOf(cls) !== -1) return node;
    return findVNode(p.children, cls);
  }

  /* ---------- autocomplete: DOM safety net for the MAP guard ---------- */
  /* The hook above rewrites the vdom, which is the clean path. This sweep
     re-checks the rendered dropdown so a template change upstream can never
     put a MAP-restricted price back on screen. */
  function acGuard() {
    var items = document.querySelectorAll('.aa-ProductItem');
    for (var i = 0; i < items.length; i++) {
      var a = items[i];
      var href = a.getAttribute('href') || '';
      var h = href.split('/products/')[1];
      h = h ? h.split('?')[0].split('#')[0] : '';
      /* keyed by handle, not a one-shot flag: the dropdown recycles its row
         elements between keystrokes, so a row that was marked once would
         keep the previous product's treatment (2026-09-11). */
      if (a.getAttribute('data-spid-map') === h) continue;
      if (!Object.prototype.hasOwnProperty.call(acHidden, h)) continue;
      a.setAttribute('data-spid-map', h);
      var el = a.querySelector('.aa-ItemContentPriceCurrent');
      if (!el || el.querySelector('.spid-ac-price')) continue;
      var rec = acHidden[h];
      el.innerHTML = '<span class="spid-ac-price">' +
        (rec.map > 0 ? '<s>' + money(rec.map) + '</s>' : '') +
        '<b>' + rec.cta + '</b></span>';
    }
  }

  /* ---------- autocomplete: part number line ----------
     The app's stock dropdown item has no part-number slot, and the results
     card prints one (h26-card__sku), so the two surfaces disagreed. Same
     pattern as acGuard(): the template hook records handle -> part number,
     this sweep prints it once per rendered row, between the title and the
     price so the running order matches the results card. */
  function acSkuLine() {
    var items = document.querySelectorAll('.aa-ProductItem');
    for (var i = 0; i < items.length; i++) {
      var a = items[i];
      var href = a.getAttribute('href') || '';
      var h = href.split('/products/')[1];
      h = h ? h.split('?')[0].split('#')[0] : '';
      /* The dropdown re-uses its row elements from one keystroke to the
         next (same <a>, new href/title/price), so the "done" mark must be
         the handle the line was printed FOR, not a one-shot flag. A flag
         froze every row's part number at its first render and the numbers
         drifted onto the wrong products as the query changed (2026-09-11). */
      if (a.getAttribute('data-spid-pn') === h) continue;
      var existing = a.querySelector('.spid-ac-sku');
      if (!Object.prototype.hasOwnProperty.call(acSkus, h)) {
        /* no part number for this product: drop a stale line, if any */
        if (existing) { existing.parentNode.removeChild(existing); }
        a.setAttribute('data-spid-pn', h);
        continue;
      }
      a.setAttribute('data-spid-pn', h);
      if (existing) { existing.textContent = '#' + acSkus[h]; continue; }
      /* .aa-ItemContentBody is the flex column (brand / title wrapper /
         price). The line has to go in as a sibling of those, NOT inside the
         title wrapper -- that wrapper is line-clamped, so anything added to
         it overflows on top of the price. */
      var body = a.querySelector('.aa-ItemContentBody');
      if (!body) continue;
      var price = a.querySelector('.aa-ItemContentPrice');
      var p = document.createElement('p');
      p.className = 'spid-ac-sku';
      p.textContent = '#' + acSkus[h];
      if (price && price.parentNode === body) { body.insertBefore(p, price); }
      else { body.appendChild(p); }
    }
  }

  /* Search attribution. The app's default card calls helpers.handleItemClick(hit),
     which saves {queryID, objectID} in localStorage so the Algolia web pixel can
     tie add-to-cart and purchase events back to the search. Our custom card
     replaces the default, so it has to make the call itself. The app writes that
     storage without checking consent, so gate it here on analytics consent via
     SPIDConsent (Shopify Customer Privacy API: allowed outside banner regions,
     off when a visitor declines or opts out). No SPIDConsent means no write. */
  function analyticsAllowed() {
    try {
      var c = window.SPIDConsent && window.SPIDConsent.get && window.SPIDConsent.get();
      return !!(c && c.analytics);
    } catch (e) { return false; }
  }
  /* Wrap the app helper once so every caller (our card, the app's own
     autocomplete items, future widgets) goes through the same consent gate. */
  function gateItemClick() {
    var h = window.algoliaShopify && window.algoliaShopify.helpers;
    if (!h || typeof h.handleItemClick !== 'function' || h.handleItemClick.__spidGated) return;
    var orig = h.handleItemClick;
    h.handleItemClick = function (hit) { if (analyticsAllowed()) return orig.apply(this, arguments); };
    h.handleItemClick.__spidGated = true;
  }
  function trackHitClick(hit) {
    try {
      gateItemClick();
      var h = window.algoliaShopify && window.algoliaShopify.helpers;
      if (h && typeof h.handleItemClick === 'function') h.handleItemClick(hit);
    } catch (e) {}
  }

  /* ---------- facets: hide filters that don't fit the current results ----------
     The app shows every facet with at least one value, so a reel page listed
     "Holds", "Rigidity" and "Lanyard width" because a few reel/holder combos
     carry those tags. A filter now shows only when it offers a real choice
     (2+ values) and its values cover at least 10% of the items on the page
     (items = variant records, the unit facet counts use; the price facet
     counts every one). A filter the shopper already used always stays,
     and Price always shows.
     algolia-2026.css hides the wrapper (header included) of a hidden panel. */
  var FACET_ALWAYS = { 'price': 1 };
  var FACET_MIN_SHARE = 0.10;
  function facetData(results, name) {
    var lists = [results.disjunctiveFacets || [], results.facets || []];
    for (var i = 0; i < lists.length; i++) {
      for (var j = 0; j < lists[i].length; j++) { if (lists[i][j].name === name) return lists[i][j].data || {}; }
    }
    return null;
  }
  function sumCounts(d) {
    var s = 0;
    for (var k in d) { if (Object.prototype.hasOwnProperty.call(d, k)) s += Number(d[k]) || 0; }
    return s;
  }
  function facetIsNoise(name, o) {
    var r = o && o.results;
    if (!r || !name || FACET_ALWAYS[name]) return false;
    var st = r._state;
    try { if (st && st.isDisjunctiveFacetRefined(name)) return false; } catch (e) {}
    try { if (st && st.isFacetRefined(name)) return false; } catch (e) {}
    var d = facetData(r, name);
    if (!d) return false;
    if (Object.keys(d).length < 2) return true;
    var base = sumCounts(facetData(r, 'price') || {}) || r.nbHits;
    return base > 0 && sumCounts(d) / base < FACET_MIN_SHARE;
  }

  /* display names for facet values whose tag must keep its spelling
     (industry:k12 drives the k-12-schools smart collection) */
  var FACET_LABELS = { 'named_tags.industry': { 'k12': 'K-12' } };

  /* ---------- custom product card template (registered as app hook) ---------- */
  function registerHooks() {
    gateItemClick();
    if (!window.algoliaShopify || !window.algoliaShopify.hooks || window.__h26Hooked) return;
    try {
      window.algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (dflt, hit, html) {
        var price = Number(hit.price), cmp = Number(hit.compare_at_price || 0);
        var hidePrice = mapGuard.hide(hit, price);
        /* strikeMap(), not mapOf(): a MAP equal to the selling price must not
           be printed -- see the comment on strikeMap. */
        var mapVal = mapGuard.strikeMap(hit, price);
        /* MAP-restricted cards must not show the "% OFF" tease either */
        var pct = (!hidePrice && cmp > price && cmp > 0) ? Math.round((1 - price / cmp) * 100) : 0;
        var img = hit.image || hit.product_image || '';
        var url = '/products/' + hit.handle + (hit.id ? '?variant=' + hit.id : '');
        var hl = (hit._highlightResult && hit._highlightResult.title && hit._highlightResult.title.value) || hit.title || '';
        /* merchandising label from label: tags (named_tags.label); one per card, priority order */
        var lab = hit.named_tags && hit.named_tags.label;
        if (lab && Object.prototype.toString.call(lab) !== '[object Array]') lab = [lab];
        if (lab) { lab = lab.filter(function (v) { return String(v).toLowerCase() !== 'custom logo'; }); } /* Custom Logo pill retired per Patrick 2026-07-25 */
        var label = '';
        if (lab && lab.length) {
          var PRI = ['Clearance', "SPID's Pick", 'Cool New Product'];
          for (var li = 0; li < PRI.length; li++) { if (lab.indexOf(PRI[li]) !== -1) { label = PRI[li]; break; } }
          if (!label) label = String(lab[0]);
        }
        var lcls = 'h26-card__label h26-card__label--' + label.toLowerCase().replace(/[^a-z0-9]+/g, '-');
        var pn = pnDisp(hit.sku, hit.vendor);
        return html`<a class="h26-card" href="${url}" data-vendor="${hit.vendor || ''}" onClick=${function () { trackHitClick(hit); }}>
          ${label ? html`<span class="${lcls}">${label}</span>` : ''}
          <img class="h26-card__img" src="${img}" loading="lazy" alt="${hit.title}" />
          <div class="h26-card__body">
            <p class="h26-card__title" dangerouslySetInnerHTML=${{ __html: hl }}></p>
            ${pn ? html`<p class="h26-card__sku" data-sku="${hit.sku}">#${pn}</p>` : ''}
            <p class="${'h26-card__price' + (hidePrice ? ' h26-card__price--map' : '')}"
               data-map="${mapVal || ''}" data-hide-price="${hidePrice ? '1' : ''}">
              ${hidePrice
                ? html`${mapVal > 0 ? html`<s>${money(mapVal)}</s>` : ''}<b class="h26-card__cta">${ctaFor(hit, price)}</b>`
                : html`<b class="${pct > 0 ? 'sale' : ''}">${money(price)}</b>${pct > 0 ? html`<s>${money(cmp)}</s><em>-${pct}%</em>` : ''}`}
            </p>
          </div>
        </a>`;
      });
      /* autocomplete: dedupe products (app queries with distinct:false when
         "show products" is off, so color variants repeat). Set distinct on the
         products plugin query; transform-hits dedupe as a safety net. */
      window.algoliaShopify.hooks.registerHook('beforeAutocompletePluginOptions', function (opts, meta) {
        try {
          if (meta && meta.pluginName === 'products' && opts) {
            var p = opts.searchParameters || opts.parameters || opts.params;
            if (p) {
              p.distinct = true;
              /* the part number line needs sku/vendor on the hit; only meddle
                 if the app has narrowed the attribute set (absent = all). */
              var atr = p.attributesToRetrieve;
              if (atr && atr.push && atr.indexOf) {
                if (atr.indexOf('sku') === -1) atr.push('sku');
                if (atr.indexOf('vendor') === -1) atr.push('vendor');
              }
            }
          }
        } catch (e) {}
        return opts;
      });
      window.algoliaShopify.hooks.registerHook('beforeAutocompleteProductTransformResponseHits', function (hits) {
        try {
          var seen = {};
          return hits.filter(function (h) {
            var k = (h && (h.handle || h.id || h.objectID)) || '';
            if (seen[k]) { return false; }
            seen[k] = 1; return true;
          });
        } catch (e) { return hits; }
      });
      /* autocomplete dropdown: same MAP guard. The app's stock product item
         prints hit.price unconditionally, so rewrite the price node of the
         vdom it hands us. Hook args (read off the app bundle 2026-07-28):
         (defaultTemplate, {item, html, components}, showProducts, url, onClick). */
      window.algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function (dflt, ctx) {
        try {
          var hit = ctx && ctx.item;
          if (!hit) return dflt;
          /* record the part number for every row, MAP-restricted or not --
             acSkuLine() prints it after the title. */
          var acPn = pnDisp(hit.sku, hit.vendor);
          if (acPn) { acSkus[String(hit.handle || '')] = acPn; }
          /* a recycled row changes href/text without adding nodes, which
             the childList observer below never sees -- sweep after render */
          schedule();
          if (!mapGuard.hide(hit, hit.price)) return dflt;
          /* remember it for the DOM sweep below -- that is the safety net if
             the app ever changes its markup and the vdom surgery misses. */
          /* strikeMap(), not mapOf(): a MAP equal to the selling price is not
             printable -- see the comment on strikeMap. */
          var acMap = mapGuard.strikeMap(hit, hit.price);
          acHidden[String(hit.handle || '')] = { map: acMap, cta: ctaFor(hit, hit.price) };
          var node = findVNode(dflt, 'aa-ItemContentPriceCurrent');
          if (node && node.props) {
            node.props.children = ctx.html`<span class="spid-ac-price">${
              acMap > 0 ? ctx.html`<s>${money(acMap)}</s>` : ''
            }<b>${ctaFor(hit, hit.price)}</b></span>`;
          }
        } catch (e) {}
        return dflt;
      });
      window.algoliaShopify.hooks.registerHook('beforeInstantSearchFacetPanelOptions', function (params, facet) {
        params = params || {};
        var name = facet && facet.name, prev = params.hidden;
        params.hidden = function (o) {
          try { return (typeof prev === 'function' && prev(o)) || facetIsNoise(name, o); } catch (e) { return false; }
        };
        return params;
      });
      window.algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
        var map = facet && FACET_LABELS[facet.name];
        if (!params || !map) return params;
        var prev = params.transformItems;
        params.transformItems = function (items, meta) {
          var out = typeof prev === 'function' ? prev(items, meta) : items;
          try {
            return out.map(function (it) { return map[it.label] ? Object.assign({}, it, { label: map[it.label] }) : it; });
          } catch (e) { return out; }
        };
        return params;
      });
      /* autocomplete redirect row: the default shows the bare query with an
         arrow ("bht ->"). Say where it goes: a badge buddy title page, or the
         custom designer pre-filled with the title (rules from bb_title_rules.py). */
      window.algoliaShopify.hooks.registerHook('beforeAutocompleteRedirectUrlOptions', function (opts) {
        opts = opts || {};
        opts.templates = {
          item: function (p) {
            var url = (p.item && p.item.urls && p.item.urls[0]) || '';
            var q = String((p.state && p.state.query) || '').trim();
            var label = 'Go to ' + q;
            try {
              var u = new URL(url, location.origin);
              var l1 = u.searchParams.get('line1');
              if (l1) {
                var l2 = u.searchParams.get('line2');
                label = 'Make a \u201c' + l1 + (l2 ? ' ' + l2 : '') + '\u201d badge buddy';
              } else if (u.pathname.indexOf('/pages/badge-buddy/') === 0) {
                label = (q.length <= 5 ? q.toUpperCase() : q.replace(/\b\w/g, function (c) { return c.toUpperCase(); })) + ' badge buddies';
              }
            } catch (e) {}
            return p.html`<a class="aa-ItemLink spid-ac-redirect" href="${url}"><span>${label}</span><span class="spid-ac-redirect__arrow" aria-hidden="true">\u2192</span></a>`;
          }
        };
        return opts;
      });
      window.__h26Hooked = true;
    } catch (e) { window.__h26Enhancer = 'hookfail: ' + e; }
  }
  registerHooks();
  document.addEventListener('algolia.hooks.initialize', registerHooks);
  window.addEventListener('load', gateItemClick);

  /* ---------- H1: Results for "query" ---------- */
  function titleize() {
    if (window.location.pathname.indexOf('/search') !== 0) return;
    var h = document.querySelector('.ais-page > h1.ais-h2');
    if (!h) return;
    var q = '';
    var qm = window.location.search.match(/[?&]q=([^&]*)/);
    if (qm) { try { q = decodeURIComponent(qm[1].replace(/\+/g, ' ')); } catch (e) { q = ''; } }
    var html;
    if (q) {
      var n = '';
      var st = document.querySelector('.ais-Stats');
      if (st) {
        var m = st.textContent.replace(/,/g, '').match(/out of\s*(\d+)/i);
        if (m) n = Number(m[1]).toLocaleString('en-US');
      }
      var d = document.createElement('div');
      d.textContent = q;
      html = 'Results for \u201C<span class="q">' + d.innerHTML + '</span>\u201D' +
        (n ? ' <span class="cnt">' + n + ' products</span>' : '');
    } else {
      html = 'Search results.';
    }
    if (h.innerHTML !== html) { h.innerHTML = html; }
    if (!h.className.match(/h26-done/)) { h.className += ' h26-done'; }
  }

  /* ---------- Not-finding-it callout ---------- */
  function callout() {
    var f = document.querySelector('.ais-facets');
    if (!f || f.querySelector('.h26-notfind')) return;
    var d = document.createElement('div');
    d.className = 'h26-notfind';
    d.innerHTML = '<b>Not finding it?</b><span>Talk to a live specialist \u2014 we\u2019ll help you find exactly what you need.</span>' +
      '<a href="tel:+18003806726">1-800-380-6726<i>\u2192</i></a>';
    f.appendChild(d);
  }

  /* ---------- pagination labels ---------- */
  function pagLabels() {
    var links = document.querySelectorAll('.ais-Pagination-link');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], t = a.textContent.trim();
      if (t === '\u00AB' || t === '\u00BB') { a.parentElement.style.display = 'none'; }
      else if (t === '\u2039') { a.textContent = '\u2190 Prev'; }
      else if (t === '\u203A') { a.textContent = 'Next \u2192'; }
    }
  }

  function sheetfix() {
    var p = document.querySelector('.ais-page');
    if (!p) return;
    p.style.setProperty('width', '100%', 'important');
    p.style.setProperty('max-width', 'none', 'important');
    p.style.setProperty('box-sizing', 'border-box', 'important');
    p.style.setProperty('margin-top', '0', 'important');
    p.style.setProperty('margin-left', '0', 'important');
    p.style.setProperty('margin-right', '0', 'important');
  }

  /* ---------- selected-filter chips: value-only pills ---------- */
  function chipfix() {
    var links = document.querySelectorAll('.ais-current-refined-values--link');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-h26') === '1') continue;
      var t = a.textContent.replace(/\s+/g, ' ').trim();
      var v = t.indexOf(':') !== -1 ? t.slice(t.indexOf(':') + 1).trim() : t;
      var m = v.match(/^(\d+)\s*:\s*(\d+)$/);
      if (m) v = '$' + m[1] + ' - $' + m[2];
      a.textContent = v;
      a.setAttribute('data-h26', '1');
      a.style.setProperty('display', 'inline-flex', 'important');
      a.style.setProperty('width', 'auto', 'important');
      a.style.setProperty('font-size', '12.5px', 'important');
      a.style.setProperty('font-family', "'Inter',system-ui,sans-serif", 'important');
      a.style.setProperty('font-weight', '700', 'important');
    }
  }

  /* ---------- facets: collapsed by default (groups with active filters stay open) ---------- */
  function collapseFacets() {
    var dds = document.querySelectorAll('.ais-dropdown-checkbox');
    for (var i = 0; i < dds.length; i++) {
      var dd = dds[i];
      if (dd.getAttribute('data-h26-c') === '1') continue;
      dd.setAttribute('data-h26-c', '1');
      var wrapper = dd.closest('.ais-facet-dropdown-wrapper');
      var hasActive = wrapper && (wrapper.querySelector('.ais-RefinementList-item--selected') ||
        wrapper.querySelector('input.ais-facet--checkbox:checked'));
      if (!hasActive && !dd.checked) { dd.click(); }
    }
  }

  /* ---------- facet search inputs: short placeholder ---------- */
  function placefix() {
    var ins = document.querySelectorAll('.ais-facets input[type="text"], .ais-facets input[type="search"]');
    for (var i = 0; i < ins.length; i++) {
      if (ins[i].placeholder && ins[i].placeholder.indexOf('Search for') === 0) { ins[i].placeholder = 'Search...'; }
    }
  }

  /* ---------- zero results (Baymard "no results page", 2026-10-21; layout pass 2026-10-22) ----------
     A dead end loses the shopper, and tips alone don't help. Three bands:
       1. gray panel: the query, shorter searches that DO match (each word of a
          multi-word query), the custom badge buddy CTA (most zero-result
          queries are role titles);
       2. "Shop by category" chips;
       3. "Best sellers": one scrolling row of the same h26 cards as the search
          grid (empty query = the index's own ranking, sales_12m first), with
          the cart carousel's side arrows.
     The rail's "Not finding it?" callout carries the phone number on desktop;
     the panel repeats it only on phones, where the rail sits in the drawer.
     The app's own "Try clearing the filters" line stays only when a filter is
     actually set.
     The 404 page (sections/main-404.liquid) reuses the category and best-seller
     bands plus a "Looking for ...?" row built from the dead URL's words --
     see notFound() below. */
  var NORES_CATS = [
    ['Lanyards', '/collections/lanyards'],
    ['Badge Reels', '/collections/badge-reels'],
    ['Badge Holders', '/collections/id-badge-holders'],
    ['Badge Buddies', '/collections/badge-buddies'],
    ['ID Card Printers', '/collections/id-card-printers'],
    ['Printer Ribbons', '/collections/printer-ribbons'],
    ['Blank ID Cards', '/collections/blank-id-cards'],
    ['Visitor Badges', '/collections/visitor-badges'],
    ['Wristbands', '/collections/wristbands'],
    ['Custom Printed', '/collections/custom-printed-products']
  ];
  var noresBest = null; /* best-seller hits, fetched once per page */

  function noresEsc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* the products index: the live search's own index on /search, else the
     app's prefix + "products" (404 page, no InstantSearch there) */
  function noresIndex() {
    var S = window.algoliaShopify;
    var is = S && S.instantsearch && S.instantsearch.search;
    if (is && is.helper) return is.helper.state.index;
    return ((S && S.config && S.config.index_prefix) || 'shopify_') + 'products';
  }

  function noresSearch(params) {
    var S = window.algoliaShopify;
    if (!S || !S.searchClient) return null;
    /* legacy array signature -- see the note in algolia-swatches.js */
    return S.searchClient.search([{ indexName: noresIndex(), params: params }]).then(function (r) {
      return r && r.results && r.results[0];
    });
  }

  function noresFilters(res) {
    try { return res.getRefinements().length > 0; } catch (e) { return false; }
  }

  /* String twin of the beforeInstantSearchProductTemplate card (same classes,
     same MAP guard), without the merchandising label. */
  function noresCard(hit) {
    var price = Number(hit.price), cmp = Number(hit.compare_at_price || 0);
    var hidePrice = mapGuard.hide(hit, price);
    var mapVal = mapGuard.strikeMap(hit, price);
    var pct = (!hidePrice && cmp > price && cmp > 0) ? Math.round((1 - price / cmp) * 100) : 0;
    var img = sizedNoresImg(hit.image || hit.product_image);
    var url = '/products/' + encodeURIComponent(hit.handle) + (hit.id ? '?variant=' + hit.id : '');
    var pn = pnDisp(hit.sku, hit.vendor);
    var priceHtml = hidePrice
      ? (mapVal > 0 ? '<s>' + money(mapVal) + '</s>' : '') + '<b class="h26-card__cta">' + noresEsc(ctaFor(hit, price)) + '</b>'
      : '<b class="' + (pct > 0 ? 'sale' : '') + '">' + money(price) + '</b>' + (pct > 0 ? '<s>' + money(cmp) + '</s><em>-' + pct + '%</em>' : '');
    return '<a class="h26-card" href="' + url + '">' +
      '<img class="h26-card__img" src="' + noresEsc(img) + '" loading="lazy" alt="' + noresEsc(hit.title) + '" width="360" height="360">' +
      '<div class="h26-card__body">' +
      '<p class="h26-card__title">' + noresEsc(hit.title) + '</p>' +
      (pn ? '<p class="h26-card__sku">#' + noresEsc(pn) + '</p>' : '') +
      '<p class="h26-card__price' + (hidePrice ? ' h26-card__price--map' : '') + '">' + priceHtml + '</p>' +
      '</div></a>';
  }

  /* the site-standard arrow (spid-rail__arrow: photo strips, designer rails) */
  function noresArrow(dir) {
    return '<button type="button" class="spid-nores__arrow spid-nores__arrow--' + dir + '" aria-label="' + (dir === 'prev' ? 'Previous products' : 'More products') + '">' +
      '<span aria-hidden="true">' + (dir === 'prev' ? '&lsaquo;' : '&rsaquo;') + '</span></button>';
  }

  /* one product row section: heading, optional "see all" link, carousel */
  function noresRowSec(cls, heading) {
    return '<section class="spid-nores__sec ' + cls + '" hidden><div class="spid-nores__head"><h4>' + heading + '</h4></div>' +
      '<div class="spid-nores__carousel">' + noresArrow('prev') + '<div class="spid-nores__row"></div>' + noresArrow('next') + '</div></section>';
  }

  /* the bands under the panel: [matches row,] categories, best sellers */
  function noresBands(withMatches) {
    var cats = '';
    for (var i = 0; i < NORES_CATS.length; i++) {
      cats += '<a class="spid-nores__chip" href="' + NORES_CATS[i][1] + '">' + NORES_CATS[i][0] + '</a>';
    }
    return (withMatches ? noresRowSec('spid-nores__matches', '') : '') +
      '<section class="spid-nores__sec"><div class="spid-nores__head"><h4>Shop by category</h4></div><div class="spid-nores__chips">' + cats + '</div></section>' +
      noresRowSec('spid-nores__best', 'Best sellers');
  }

  /* fill a row section with cards and wire its arrows */
  function noresPaintRow(box, hits) {
    if (!box || !hits || !hits.length) return;
    var html = '';
    for (var k = 0; k < hits.length; k++) { html += noresCard(hits[k]); }
    var row = box.querySelector('.spid-nores__row');
    row.innerHTML = html;
    box.hidden = false;
    var prev = box.querySelector('.spid-nores__arrow--prev'), next = box.querySelector('.spid-nores__arrow--next');
    var step = function (dir) {
      var card = row.querySelector('.h26-card');
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      var w = card ? card.getBoundingClientRect().width + gap : row.clientWidth;
      row.scrollBy({ left: dir * w * Math.max(1, Math.round((row.clientWidth + gap) / w)), behavior: 'smooth' });
    };
    var sync = function () {
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    };
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  /* best sellers: 32 = four pages of 8 */
  function noresBestInto(d) {
    var box = d.querySelector('.spid-nores__best');
    if (noresBest) { noresPaintRow(box, noresBest); return; }
    var best = noresSearch({ query: '', hitsPerPage: 32, distinct: true, analytics: false, clickAnalytics: false, attributesToHighlight: [] });
    if (best) {
      best.then(function (r) { noresBest = (r && r.hits) || []; if (document.body.contains(d)) noresPaintRow(box, noresBest); }, function () {});
    }
  }

  function noResultsCTA() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var existing = document.getElementById('spid-nores');
    var is = window.algoliaShopify && window.algoliaShopify.instantsearch && window.algoliaShopify.instantsearch.search;
    var res = is && is.helper && is.helper.lastResults;
    if (!res) return;
    var container = document.querySelector('.ais-hits-container');
    if (!container) return;
    if (res.nbHits > 0 || !res.query) {
      if (existing) { existing.parentNode.removeChild(existing); }
      document.documentElement.classList.remove('spid-nores-on');
      return;
    }
    document.documentElement.classList.toggle('spid-nores-on', !noresFilters(res));
    if (existing && existing.getAttribute('data-q') === res.query) return;
    if (existing) { existing.parentNode.removeChild(existing); }
    var q = res.query;
    var d = document.createElement('div');
    d.id = 'spid-nores';
    d.className = 'spid-nores';
    d.setAttribute('data-q', q);
    d.innerHTML =
      '<div class="spid-nores__panel">' +
      '<h3>No exact matches for &ldquo;<span class="spid-nores__q"></span>&rdquo;</h3>' +
      '<div class="spid-nores__alt" hidden></div>' +
      '<p>Searching for a job title or role? We print custom badge buddies for any title &mdash; pick your colors, add your text, done.</p>' +
      '<div class="spid-nores__btns">' +
      '<a class="spid-nores__btn spid-nores__btn--primary" href="/products/custom-printed-badge-buddy-horizontal">Design a Custom Badge Buddy</a>' +
      '<a class="spid-nores__btn" href="/search?q=badge%20buddy">Browse Badge Buddies</a>' +
      '</div>' +
      '<p class="spid-nores__call">Or call <a href="tel:18003806726">1-800-380-6726</a> and a specialist will find it for you.</p>' +
      '</div>' + noresBands(false);
    d.querySelector('.spid-nores__q').textContent = q;
    container.parentNode.insertBefore(d, container);

    /* shorter searches: each word of a multi-word query that has results */
    var words = q.toLowerCase().split(/\s+/).filter(function (w, k, a) { return w.length > 2 && a.indexOf(w) === k; }).slice(0, 5);
    if (words.length > 1) {
      var reqs = words.map(function (w) { return noresSearch({ query: w, hitsPerPage: 0, analytics: false }); });
      if (reqs[0]) {
        Promise.all(reqs).then(function (rs) {
          if (!document.body.contains(d)) return;
          var links = '';
          for (var j = 0; j < rs.length; j++) {
            if (rs[j] && rs[j].nbHits > 0) {
              links += '<a class="spid-nores__chip" href="/search?q=' + encodeURIComponent(words[j]) + '">' + noresEsc(words[j]) + ' <span>(' + rs[j].nbHits + ')</span></a>';
            }
          }
          if (!links) return;
          var alt = d.querySelector('.spid-nores__alt');
          alt.innerHTML = '<span class="spid-nores__altlabel">Try a shorter search:</span>' + links;
          alt.hidden = false;
        }, function () {});
      }
    }
    noresBestInto(d);
  }

  /* ---------- 404 page (2026-10-22) ----------
     sections/main-404.liquid renders the panel (message, search box, phone)
     and an empty #spid-404-bands. Most 404s are retired product URLs, so the
     dead URL's last segment becomes a query ("/products/evolis-r2011-
     monochrome-ribbon-1000-prints" -> "evolis r2011 monochrome ribbon 1000
     prints") and its matches lead the page; then categories + best sellers. */
  var NF_STOP = ['products', 'product', 'collections', 'collection', 'pages', 'blogs', 'all', 'default', 'asp', 'htm', 'html', 'php', 'aspx', 'the', 'and', 'with', 'for', 'p', 'c'];
  function notFoundQuery() {
    var segs = location.pathname.split('/').filter(Boolean);
    var last = '';
    try { last = decodeURIComponent(segs[segs.length - 1] || ''); } catch (e) { last = segs[segs.length - 1] || ''; }
    last = last.replace(/\.(html?|aspx?|php)$/i, '');
    var words = last.toLowerCase().replace(/[^a-z0-9]+/g, ' ').split(' ').filter(function (w, k, a) {
      return w && NF_STOP.indexOf(w) === -1 && a.indexOf(w) === k && (w.length > 1 || /\d/.test(w));
    });
    /* base64-ish junk (no vowels in a long token, or mixed case noise) is not a query */
    if (words.length === 1 && words[0].length > 7 && !/[aeiou]/.test(words[0])) return '';
    return words.slice(0, 7).join(' ');
  }

  function notFound() {
    var mount = document.getElementById('spid-404-bands');
    if (!mount || mount.getAttribute('data-built')) return;
    if (!window.algoliaShopify || !window.algoliaShopify.searchClient) return;
    mount.setAttribute('data-built', '1');
    var q = notFoundQuery();
    mount.className = 'spid-nores spid-nores--404';
    mount.innerHTML = noresBands(!!q);
    var input = document.querySelector('.spid-404 input[name="q"]');
    if (q && input && !input.value) { input.value = q; }
    if (q) {
      var m = noresSearch({ query: q, hitsPerPage: 16, distinct: true, analytics: false, clickAnalytics: false, attributesToHighlight: [],
        removeWordsIfNoResults: 'allOptional' });
      if (m) {
        m.then(function (r) {
          if (!r || !r.nbHits) return;
          var box = mount.querySelector('.spid-nores__matches');
          var head = box.querySelector('.spid-nores__head');
          head.innerHTML = '<h4>Looking for &ldquo;<span class="spid-nores__q"></span>&rdquo;?</h4>' +
            '<a class="spid-nores__all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';
          head.querySelector('.spid-nores__q').textContent = q;
          noresPaintRow(box, r.hits);
        }, function () {});
      }
    }
    noresBestInto(mount);
  }

  function sizedNoresImg(url) { if (!url) return ''; return String(url).split('?')[0] + '?width=360'; }

  /* ---------- /search?q= follows Algolia redirect rules ----------
     The header autocomplete already follows a rule's redirect (badge buddy
     titles -> title page or pre-filled designer). A /search?q=... link opened
     directly does not, so follow it here -- only for the query the page was
     opened with, never while the shopper types in the results-page box. */
  var initialQ = (function () {
    try { return location.pathname === '/search' ? (new URLSearchParams(location.search).get('q') || '').trim().toLowerCase() : ''; } catch (e) { return ''; }
  })();
  var redirectChecked = false;
  function searchRedirect() {
    if (!initialQ || redirectChecked) return;
    var is = window.algoliaShopify && window.algoliaShopify.instantsearch && window.algoliaShopify.instantsearch.search;
    var r = is && is.helper && is.helper.lastResults;
    if (!r) return;
    redirectChecked = true;
    var url = r.renderingContent && r.renderingContent.redirect && r.renderingContent.redirect.url;
    if (url && String(r.query || '').trim().toLowerCase() === initialQ && /^https:\/\/www\.specialistid\.com\//.test(url)) {
      location.replace(url);
    }
  }

  function run() {
    try { searchRedirect(); titleize(); callout(); pagLabels(); sheetfix(); chipfix(); collapseFacets(); placefix(); noResultsCTA(); notFound(); acGuard(); acSkuLine(); window.__h26Enhancer = 'ran'; } catch (e) { window.__h26Enhancer = 'error: ' + e; }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 120);
  }

  schedule();
  var tries = 0;
  var iv = setInterval(function () { run(); registerHooks(); if (++tries >= 8) clearInterval(iv); }, 900);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
